
import loginReducer from '../Store/loginRedux/reducers';
import dataReducer from '../Store/data/reducers';
import prospectReducer from '../Store/prospect/reducers';
import recommendedReducer from '../Store/recommended/reducers';
import cotizadorReducer from '../Store/secureInvestmentIncome/reducers';
import briefcaseReducer  from '../Store/briefcase/reducers';
import valuesFormReducer from '../Store/valuesForm/reducers';
import quizReducer from '../Store/quiz/reducers';
import simulateReducer from './simulate/reducers';
import quoteReducer from './quote/reducers';
import adviserReducer from './adviser/reducers';
import requestPdfReducer from './requestPdf/reducer';
import improveRateReducer from './improveRate/reducers';
import configReducer from './config/reducers';
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage' 
import {combineReducers} from 'redux';



const config = {
    key: "root",
    storage,
  };
  const config2= {
    key: "root2",
    storage,
  };
  const config3= {
    key: "root3",
    storage,
  };
  const config4= {
    key: "root4",
    storage,
  };
  const config5= {
    key: "root5",
    storage,
  };

  const rootReducers = combineReducers({
    login: persistReducer(config, loginReducer),
    cotizador : persistReducer(config2, cotizadorReducer),
    briefcase:briefcaseReducer,
    form : valuesFormReducer,
    simulate : simulateReducer,
    quote : quoteReducer,
    requestPdf : requestPdfReducer,
    adviser : persistReducer(config4, adviserReducer),
    quiz : persistReducer(config3, quizReducer),
    improveRate : improveRateReducer,
    config : persistReducer(config5, configReducer),
    data : dataReducer,
    prospect: prospectReducer,
    recommended: recommendedReducer
  })


export default rootReducers;